
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Login from "./pages/Login";
import SignIn from "./pages/SignIn";
import Profile from "./pages/Profile";
import WeeklyIssue from "./components/dashboard/WeeklyIssue";
import FirstAnalysis from "./components/dashboard/FirstAnalysis";
import FAQ from "./pages/FAQ";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import DevEngine from "./pages/DevEngine";
import DevArchitecture from "./pages/DevArchitecture";
import DevDecisionEngine from "./pages/DevDecisionEngine";

const queryClient = new QueryClient();

console.log("App.tsx: Initializing application with routes");

const App = () => {
  console.log("App.tsx: Rendering App component");
  
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/preview/weekly-issue" element={<WeeklyIssue />} />
            <Route path="/preview/first-analysis" element={<FirstAnalysis />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dev/engine" element={<DevEngine />} />
            <Route path="/dev/architecture" element={<DevArchitecture />} />
            <Route path="/dev/decision-engine" element={<DevDecisionEngine />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
